export const containerStyles = `
   flex flex-col items-center
   p-4
   relative
`

export const webAppMobileScreenStyles = `
   flex flex-col items-center justify-center flex-1
`

export const logoStyles = 'absolute top-[40px]'

export const socialMediasContainerStyles =
   'flex flex-col justify-center items-center gap-2 mt-[89px]'

export const socialMediaListContainerStyles = 'flex gap-4'

export const sectionSeparatorContainerStyles =
   'flex gap-[11px] mt-6 items-center'

export const getSectionSeparatorTextStyles = `text-xs-regular text-gray-700`

export const getHorizontalLineStyles = `bg-gray-300 h-[1px] w-[140px]`

export const getDescriptionStyles = `text-md-medium text-gray-700 text-center py-6 pr-[26px] pl-[25px]`

export const getFollowUsOnTextStyles = `text-xs-regular text-gray-500`

export const desktopViewImageStyles = `
   w-full
`
